<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <a href="/dashboard/map" class="btn btn-cyan"><i class="fa fa-arrow-circle-left"></i></a>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">

      <h4 class="text-center" style="font-size: 28px;">Cascade of services accessed by PWID  ({{ activeCity }})</h4>
      </div>
      <div class="col-md-7">
      <div id="container"  class="mt-5"></div>
      <div class="margin-top-minus-150">
        <div id="testedReactivePieChart"></div>
      </div>
    </div>
      <div class="col-md-5">
      <svg
        id="map2"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="450 800 728 844"
        style="display: block"
      >
         <g
          class="model-green shadow filter-shaddow"
          id="Sindh"
          fill="#ffffd0"
          stroke="#d0c0a0"
          transform="translate(-27.1,-28.1)"
        >
          <a
            id="state_Umerkot"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Umerkot"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 911.4,1402.6 20.6,-11.8 38.8,-1 -5.6,-22.4 5.4,-12 -14,-6 10.8,-10.6 -6.6,-9.6 -15.4,5.4 -9.2,-1.8 -21.8,25.8 -16.2,3.8 1.4,-7.6 -39.4,-1.4 1.4,16.4 21.6,18.4 -2,18.2 8.2,28.4 14,-20 11.8,4.6 z"
            />
          </a>

          <a
            id="state_Tharparkar"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Tharparkar"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1001,1338.2 -20.2,4.2 -13.4,-3.6 -10.8,10.6 14,6 -5.4,12 5.6,22.4 -38.8,1 -20.6,11.8 3.8,16.8 -11.8,-4.6 -14,20 -14.6,8.8 -9,14.2 -1.6,17.8 -16.4,10.8 1.2,18.4 10.8,3.8 11,-4.8 13.2,0.8 14.8,-1.8 13.4,12.8 30,0.6 8.6,-13.2 26,-8 20.4,-7.6 2,3.4 -3.2,3.8 1.2,12 10,3.4 13.2,0.2 9.8,-5 -3.8,-3.8 11.4,-7.4 3.4,1.2 11,-6.6 -10.4,-2.8 -3,-19.4 9.6,-10.4 -14,-26.4 -7,-26.4 -21,-28 0.6,-31.6 z"
            />
          </a>

          <a
            id="state_Thatta"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            data-toggle="tooltip"
            data-html="true"
            title="Thatta"
            v-on:click="triggerChart(6); return false;"
          >
            <path
              id="Thatta"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['THA']]"


              d="m 689.8,1550.2 11.4,3.2 3.2,-9.4 3,15.6 6.6,-0.4 -2.2,-5.2 11.8,3.6 2,-11.6 16.6,16.6 -1.4,-19.6 5.6,2.4 3.4,12.6 -5,9.6 4.6,2.8 1,-3.8 4.4,5 0.8,-24.2 3.8,14.4 4.6,-14.4 12.8,-9.6 38,2.2 1.4,-36.4 -2,-10.2 -30,-4.6 -3.4,-38.8 -9.4,-11 2.6,-9 -4.2,-12.2 2.4,-9.6 -2.4,-19.2 -7.4,-0.4 -14.6,-16.8 -10.8,10.4 0.2,7.4 -8.8,6 0,15.6 -9.8,10.6 -24.8,5.4 3.2,23.4 -13,-7.6 -18.6,7.8 -6,3 -5,8 1,4 5.6,-0.4 4,3.2 -6,3.2 3.8,3.8 2.8,12.6 2.8,-2.6 -0.8,9 8.2,1.8 -7.2,3.4 5,25.6 19.8,4 0.2,13.4 z"
            />
          </a>

          <a
            id="state_Tando_Muhammad_Khan"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Tando_Muhammad_Khan"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 771.4,1439 9.4,11 14.4,-13.8 6.4,2.4 8,-5.8 7.2,0.6 1,-7.2 -15.4,-13.8 -2.2,-4.2 -28,0 -2.4,9.6 4.2,12.2 z"
            />
          </a>

          <a
            id="state_Tando_Allahyar"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Tando_Allahyar"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 821.2,1336 -10,9 0.6,10 -6.4,9.8 3.2,13.6 -4.4,5.8 3.8,5.8 5.4,-0.2 0.8,5.8 18.8,0 6.2,-9.4 0.6,-13 -6.8,-13.6 0.6,-18.4 z"
            />
          </a>

          <a
            id="state_Sukkur"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            data-toggle="tooltip"
            data-html="true"
            title="Sukkur"
            v-on:click="triggerChart(36); return false;"
          >
            <path
              id="Sukkur"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['SUK']]"


              d="m 830.2,1154.7 17.6,14.4 43.2,20 7.4,-18.8 23.8,-24.6 -20.6,-8 0.2,-7.6 -20.6,-1.6 -17.8,-22.2 10,-1 -9.2,-29 -10.6,-3 -23.8,24.4 -12.4,2.6 -5.6,6.4 8.8,6.2 12,0 -6.2,19.4 9.2,6.8 z"
            />
          </a>

          <a
            id="state_Shikarpur"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Shikarpur"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 817.4,1100.3 12.4,-2.6 23.8,-24.4 -4.2,-5.8 -11,-1.2 -24.8,-8.2 -22.4,7 -10.4,-2.6 -0.4,21.6 -6.4,2.2 19,26.2 18.8,-5.8 z"
            />
          </a>

          <a
            id="state_Sanghar"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            v-on:click="triggerChart(8)"
            data-toggle="tooltip"
            data-html="true"
            title="Sanghar"
          >
            <path
              id="Sanghar"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['SAN']]"


              d="m 811.2,1345 10,-9 12.4,5.2 10,-4.8 13.6,6 3,11 39.4,1.4 -1.4,7.6 16.2,-3.8 21.8,-25.8 9.2,1.8 15.4,-5.4 -10.8,-15.8 -2.2,-14.4 -90.4,-17.8 -23.6,-26.4 -24,20 4.4,8.8 -8.8,3 -10.2,-8 -9.4,6.8 11.4,16 -4.2,13.6 3.2,11.2 z"
            />
          </a>

          <a
            id="state_Qambar_Shahdatkot"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Qambar_Shahdatkot"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 662.6,1124.7 -9.6,29.2 94.8,7.2 7.2,-9 -1,-12.4 8.4,-22.6 8.6,-19 -5.6,-3.4 -3,-10.8 -8.8,-5.2 -12.2,0 -9.4,-5 -26,11.4 -27.6,6 z"
            />
          </a>

          <a
            id="state_Nawabshah"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            v-on:click="triggerChart(4)"
            data-toggle="tooltip"
            data-html="true"
            title="Nawabshah"
          >
            <path
              id="Nawabshah"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['NWS']]"


              d="m 818,1237.6 -40.2,-2.6 -27.8,5.2 -10.6,7 -4,23.6 28.6,37.8 9,-0.2 10.6,-11.4 13.6,4.4 -11.4,-16 9.4,-6.8 10.2,8 8.8,-3 -4.4,-8.8 24,-20 z"
            />
          </a>

          <a
            id="state_Naushahro_Firoze"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            v-on:click="triggerChart(5)"
            data-toggle="tooltip"
            data-html="true"
            title="NaushahroFeroze"
          >
            <path
              id="Naushahro_Firoze"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['NOF']]"


              d="m 729.8,1210.8 5.6,22.2 -6,6.6 10,7.6 10.6,-7 27.8,-5.2 2,-29.6 9.8,-27.1 -24.2,-12.8 -12.8,13.8 -10.2,6.6 3.4,10 z"
            />
          </a>

          <a
            id="state_Shikarpur"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            v-on:click="triggerChart(3)"
          >
            <path
              id="Mirpur_Khas"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['MPK']]"


              d="m 860.2,1353.4 -3,-11 -13.6,-6 -10,4.8 -0.6,18.4 6.8,13.6 -0.6,13 4,22 18.6,17.6 10.2,3.4 2.8,14.4 14.6,-8.8 -8.2,-28.4 2,-18.2 -21.6,-18.4 z"
            />
          </a>

          <a
            id="state_Matiari"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Matiari"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 793,1315 4.2,-13.6 -13.6,-4.4 -10.6,11.4 -3.2,8.6 9.6,9 -2.2,9.4 15,9.4 -3.6,-13.2 7.6,-5.4 z"
            />
          </a>

          <a
            id="state_Larkana"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            data-toggle="tooltip"
            data-html="true"
            title="Larkana"
            v-on:click="triggerChart(27); return false;"
          >
            <path
              id="Larkana"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['LRK']]"


              d="m 773,1152.1 9.2,-1.8 -8.2,-14.8 8.2,-12.8 16.2,-3.6 -5.4,-6.6 -19,-26.2 -11.6,-2.4 3,10.8 5.6,3.4 -8.6,19 -8.4,22.6 1,12.4 -7.2,9 -4.4,8.6 9.2,9.6 12.8,-13.8 z"
            />
          </a>

          <a
            id="state_Khairpur"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            data-toggle="tooltip"
            data-html="true"
            title="Khairpur"
            v-on:click="triggerChart(2)"
          >
            <path
              id="Khairpur"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['KHP']]"


              d="m 765.4,1165.5 24.2,12.8 -9.8,27.1 -2,29.6 40.2,2.6 15.8,17.2 23.6,26.4 90.4,17.8 9.2,-21.6 -0.4,-35 -10.2,-5.6 -18.6,2 -39,-21 2.2,-28.7 -43.2,-20 -17.6,-14.4 5.4,-15.6 -9.2,-6.8 6.2,-19.4 -12,0 -8.8,-6.2 -18.8,5.8 5.4,6.6 -16.2,3.6 -8.2,12.8 8.2,14.8 -9.2,1.8 z"
            />
          </a>

          <a
            id="state_Kashmore"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Kashmore"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 878.4,1019.7 -25,0.8 -15,45.8 11,1.2 4.2,5.8 10.6,3 6.4,-11 24.6,-13 7,8 21,-22 -11.6,-16.8 -23.6,-6.2 z"
            />
          </a>

          <a
            id="state_Karachi"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            data-toggle="tooltip"
            data-html="true"
            title="Karachi"
            v-on:click="triggerChart(20)"
          >
            <path
              id="Karachi"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['KHI']]"


              d="m 671.6,1403.2 19,13.4 3.2,10.6 3.2,23.4 -13,-7.6 -18.6,7.8 -2.2,-4.2 -5,2.4 -10.6,-5 -0.2,3.6 -12,-8.6 0.2,4.2 -9.8,-5.8 -20.4,3.4 5,-7.6 17,-14.6 6.8,-0.6 8,-9.4 0.4,-7.2 10.6,-10.8 3.4,-18.2 20.8,-27.2 9.2,11.4 -2.2,17.8 z"
            />
          </a>

          <a
            id="state_Jamshoro"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Jamshoro"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 739.4,1247.2 -10,-7.6 -14.6,-5 -7.4,37.2 -9.4,-0.2 -12.8,22.2 -0.6,29.6 -7.2,21.8 9.2,11.4 -2.2,17.8 -12.8,28.8 19,13.4 3.2,10.6 24.8,-5.4 9.8,-10.6 0,-15.6 8.8,-6 -0.2,-7.4 10.8,-10.4 14.6,16.8 7.4,0.4 11.4,1.6 -6.6,-21.4 10.2,-7.8 -3.4,-9 10.8,-7.6 -15,-9.4 2.2,-9.4 -9.6,-9 3.2,-8.6 -9,0.2 -28.6,-37.8 z"
            />
          </a>

          <a
            id="state_Jacobabad"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            data-toggle="tooltip"
            data-html="true"
            title="Jacobabad"
            v-on:click="triggerChart(1)"
          >
            <path
              id="Jacobabad"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['JAC']]"


              d="m 853.4,1020.5 -15,45.8 -24.8,-8.2 -22.4,7 -10.4,-2.6 -0.4,21.6 -6.4,2.2 -11.6,-2.4 -8.8,-5.2 -12.2,0 -9.4,-5 10.6,-15.2 32.6,-21.4 11.8,-14.2 z"
            />
          </a>

          <a
            id="state_Hyderabad"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            data-toggle="tooltip"
            data-html="true"
            title="Hyderabad"
            v-on:click="triggerChart(37)"
          >
            <path
              id="Hyderabad"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['HYD']]"


              d="m 800.2,1408.2 2.2,4.2 11.4,-5.6 0.4,-11.2 -0.8,-5.8 -5.4,0.2 -3.8,-5.8 4.4,-5.8 -3.2,-13.6 6.4,-9.8 -0.6,-10 -15,-18.8 -7.6,5.4 3.6,13.2 -10.8,7.6 3.4,9 -10.2,7.8 6.6,21.4 -11.4,-1.6 2.4,19.2 z"
            />
          </a>

          <a
            id="state_Ghotki"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Ghotki"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 901.8,1130.1 -0.2,7.6 20.6,8 20,-20.6 8.4,-22.6 9.8,-13.4 -18,-8.4 -13,-17.8 -6.2,-24.6 -21,22 -7,-8 -24.6,13 -6.4,11 9.2,29 -10,1 17.8,22.2 z"
            />
          </a>

          <a
            id="state_Dadu"
            class="state"
            xlink:href="javascript:void(0);"
            v-on:click="triggerChart(0)"
            data-toggle="tooltip"
            data-html="true"
            title="Dadu"
          >
            <path
              id="Dadu"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['DAD']]"


              d="m 752.6,1179.3 -9.2,-9.6 4.4,-8.6 -94.8,-7.2 1.4,73.3 8,26.8 22.8,39.8 12.8,-22.2 9.4,0.2 7.4,-37.2 14.6,5 6,-6.6 -5.6,-22.2 16,-14.9 -3.4,-10 z"
            />
          </a>

          <a
            id="state_Badin"
            class="state"
            xlink:href="javascript:void(0);"
            v-on:click="triggerChart(7)"
            data-toggle="tooltip"
            data-html="true"
            title="Badin"
          >
            <path
              id="Badin"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['BAD']]"


              d="m 784.2,1488.8 30,4.6 2,10.2 6.2,-3.4 3,12.2 6.8,-10.8 7,8.2 9.8,-5 -1.2,-18.4 16.4,-10.8 1.6,-17.8 9,-14.2 -2.8,-14.4 -10.2,-3.4 -18.6,-17.6 -4,-22 -6.2,9.4 -18.8,0 -0.4,11.2 -11.4,5.6 15.4,13.8 -1,7.2 -7.2,-0.6 -8,5.8 -6.4,-2.4 -14.4,13.8 z"
            />
          </a>

          <path
            id="Sindh_Border"
            fill="none"
            stroke="#a08070"
            d="m 911.6,1021.5 -23.6,-6.2 -9.6,4.4 -35,1.2 -56.4,2 -11.8,14.2 -32.6,21.4 -10.6,15.2 -26,11.4 -27.6,6 -15.8,33.6 -9.6,29.2 1.4,73.3 8,26.8 22.8,39.8 -0.6,29.6 -7.2,21.8 -20.8,27.2 -3.4,18.2 -10.6,10.8 -0.4,7.2 -8,9.4 -6.8,0.6 -17,14.6 -5,7.6 20.4,-3.4 9.8,5.8 -0.2,-4.2 12,8.6 0.2,-3.6 10.6,5 5,-2.4 2.2,4.2 -6,3 -5,8 1,4 5.6,-0.4 4,3.2 -6,3.2 3.8,3.8 2.8,12.6 2.8,-2.6 -0.8,9 8.2,1.8 -7.2,3.4 5,25.6 19.8,4 0.2,13.4 -3.8,7.4 11.4,3.2 3.2,-9.4 3,15.6 6.6,-0.4 -2.2,-5.2 11.8,3.6 2,-11.6 16.6,16.6 -1.4,-19.6 5.6,2.4 3.4,12.6 -5,9.6 4.6,2.8 1,-3.8 4.4,5 0.8,-24.2 3.8,14.4 4.6,-14.4 12.8,-9.6 38,2.2 1.4,-36.4 6.2,-3.4 3,12.2 6.8,-10.8 7,8.2 9.8,-5 10.8,3.8 11,-4.8 13.2,0.8 14.8,-1.8 13.4,12.8 30,0.6 8.6,-13.2 26,-8 20.4,-7.6 2,3.4 -3.2,3.8 1.2,12 10,3.4 13.2,0.2 9.8,-5 -3.8,-3.8 11.4,-7.4 3.4,1.2 11,-6.6 -10.4,-2.8 -3,-19.4 9.6,-10.4 -14,-26.4 -7,-26.4 -21,-28 0.6,-31.6 -6,-5.4 -20.2,4.2 -13.4,-3.6 -6.6,-9.6 -10.8,-15.8 -2.2,-14.4 9.2,-21.6 -0.4,-35 -10.2,-5.6 -18.6,2 -39,-21 2.2,-28.7 7.4,-18.8 23.8,-24.6 20,-20.6 8.4,-22.6 9.8,-13.4 -18,-8.4 -13,-17.8 -6.2,-24.6 z"
          />
        </g>
 <g
                    id="Labels"
                    font-size="10"
                    font-family="DejaVu Sans"
                    transform="translate(-27.1,-28.1)"
                >
                    <text y="1491.9277" x="717.02856">THATTA</text>
                    <text y="1431.666" x="640.90259">KARACHI</text>
                    <!-- <text y="1460.0664" x="928.1272">THARPARKAR</text> -->
                    <text y="1465.2412" x="813.07843">BADIN</text>
                    <!-- <text y="1428.7881" x="788.802">• TANDO MOHAMMAD KHAN</text> -->
                    <!-- <text y="1345.9844" x="706.37518">JAMSHORO</text> -->
                    <text y="1371.9961" x="725.42206">HYDERABAD •</text>
                    <!-- <text y="1319.6025" x="739.41626">MATIARI •</text> -->
                    <text y="1262.9736" x="748.87329">NAWABSHAH</text>
                    <text y="1316.2168" x="843.80005">SANGHAR</text>
                    <!-- <text y="1381.916" x="897.29321">UMERKOT</text> -->
                    <text y="1397.0664" x="787.1936">MIRPUR KHAS •</text>
                    <text y="1208.4813" x="681.63312">DADU</text>
                    <text y="1252.9824" x="856.86255">KHAIRPUR</text>
                    <text y="1207.1826" x="758.35571">• NAUSHAHRO FIROZE</text>
                    <!-- <text y="1120.0273" x="600.29907">QAMBAR SHAHDATKOT •</text> -->
                    <text y="1145.9004" x="763.85571">• LARKANA</text>
                    <text y="1049.502" x="775.41431">JACOBABAD</text>
                    <text y="1146.6504" x="847.04028">SUKKUR</text>

                </g>

      </svg>
      <div class="positive-ratio-colors"  v-on:click="triggerChart(45)">
        <button
          type="button"
          class="btn btn-default text-white text-bold btn-ratio"
          style="background: rgb(245, 183, 177); width:70px; font-size: 10px;"
        >
          < 20%
        </button>
        <br />
        <button
          type="button"
          class="btn btn-default text-white text-bold btn-ratio"
          style="background: rgb(255 141 129); width:70px; font-size: 10px;"
        >
          21-40%
        </button>
        <br />
        <button
          type="button"
          class="btn btn-default text-white text-bold btn-ratio"
          style="background: rgb(228 94 80); width:70px; font-size: 10px;"
        >
          41-60%
        </button>
        <br />
        <button
          type="button"
          class="btn btn-default text-white text-bold btn-ratio"
          style="background: rgb(226, 23, 23); width:70px; font-size: 10px;"
        >
           60% +
        </button>
      </div>
    </div>

    </div>
  </div>
</template>

<script>
import NSEPIndicators from '../indicators/NSEPIndicators.vue';
import PunjabIndicators from "../indicators/PunjabIndicators.vue";
export default {
    name : 'punjab-map',
    components: { PunjabIndicators, NSEPIndicators },
    data() {
    return {
      citiesColors: [],
      loader: true,
      chart: null,
      chartSpouse: null,
      isClient: true,
      tested: null,
      reactive: null,
      tableDataCities: null,
      citySpots: 0,
      activeCity : 'Overall Sindh',
    };
  },
  methods: {
    async callPositivePWID() {
      await axios
        .get("prevalenceHtc")
        .then((response) => {
          if (response.status == 200) {
            this.citiesColors = response.data;
            loader = false;
          }
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loader = false));
    },
    async callPWID() {
      var dataSeries = [];
      var column = {
        data: [],
      };
      await axios
        .get("byCitiesPWIDSindh")
        .then((response) => {
          response.data.forEach((data) => {
            column.name = data.CityShortName;
            if (column.name == "AllSindh") {
              column.visible = true;
              column.color = "#287161";
            } else {
              column.visible = false;
              column.color = "#287161";
            }
            column.data.push(parseInt(data.ActiveCases));
            column.data.push(parseInt(data.DistinctVCCT));
            column.data.push(parseInt(data.Reactive));
            column.data.push(parseInt(data.RegART));
            column.data.push(parseInt(data.OnART));
            column.data.push(parseInt(data.CompletedAAU));
            column.data.push(parseInt(data.Adherent));
            column.data.push(parseInt(data.ViralLoadTested));
            column.data.push(parseInt(data.ViralLoadSuppressed));


            dataSeries.push(column);
            column = {
              data: [],
            };
          });
          dataSeries.forEach(this.colorizeData);
          this.chart = Highcharts.chart("container", {
            chart: {
              type: "column",
              animation: false,
            },
            title: {
              text: "",
            },
            xAxis: {
              categories: [
                "Active<br>Cases",
                "Tested",
                "Reactive",
                "ART<br>Registered",
                "On<br>ART",
                "Completed<br>AAU",
                "Adherent",
                "ViralLoad<br>Tested",
                "VL<br>Supressed",
              ],
              labels : {
                useHTML : true,
                style : {
                  fontSize: '10px',
                  wordBreak: 'break-all',
                  fontWeight: '700'
                }
              },
              crosshair: true,
            },
            yAxis: {
              stackLabels: {
                style: {
                    fontSize: '2px',
                },
                enabled: false,
              },
              min: 0,
              title: {
                text: "Number of PWID",
              },
            },
            tooltip: {
              headerFormat:
                '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat:
                '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y}</b></td></tr>',
              footerFormat: "</table>",
              shared: true,
              useHTML: true,
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0,
              },
              color: {
                radialGradient: { cx: 0.5, cy: 0.5, r: 0.5 },
                stops: [
                  [0, "#003399"],
                  [1, "#3366AA"],
                ],
              },
              series: {
                 pointPadding: 0,
                groupPadding: 0,
                point: {
                  events: {
                    click: function(){
                      // console.log(this.name)
                      // console.log(this.category)
                      // console.log(this.x)
                      // console.log(this.y)
                    }
                  }
                },
                dataLabels: {
                  enabled: true,
                  style: {
                      fontSize: '12px',
                      fontWeight: '700'
                  },
                  // format: ':- ({y}) <br/> {point.percentage:.1f}%',
                  formatter: function() {
                      return Number(this.y).toLocaleString();
                      // return this.y + '<br>' + this.x
                  }
                }
              },
            },
            credits: {
              enabled: false,
            },
            legend: {
                enabled: false
            },
            series: dataSeries,
          });
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loader = false));
    },
    async callPWIDPositiveTested(){
      await axios
        .get("pwidReactiveTestedSindh")
        .then((response) => {
          if (response.status == 200) {
            this.tableDataCities = response.data;

            this.populatePieCharts('All');
          }
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loader = false));
    },
    populatePieCharts(city){

      var testedReactiveData = [{
        name : 'Reactive',
        y : parseInt(this.tableDataCities[city].Reactive)
      }, {
        name : 'Tested',
        y : parseInt(this.tableDataCities[city].DistinctVCCT) - parseInt(this.tableDataCities[city].Reactive)
      }];

      var genderData = [{
        name : 'Male',
        y : parseInt(this.tableDataCities[city].Male)
      }, {
        name : 'Female',
        y : parseInt(this.tableDataCities[city].Female)
      }];

      var ageData = [{
        name : 'Age > 25',
        y : parseInt(this.tableDataCities[city].Male25Greater)
      }, {
        name : 'Age < 25',
        y : parseInt(this.tableDataCities[city].Male25Less)
      }];

      this.populateTestedReactiveGender(testedReactiveData, genderData, ageData);
    },
    populateTestedReactiveGender(testedreactive, genders, ages){
      var chart = Highcharts.chart('testedReactivePieChart', {
          chart: {
              plotBackgroundColor: null,
              plotBorderWidth: null,
              plotShadow: false,
              type: 'pie'
          },
          title: {
              text: 'PWID Tested/Reactive Past 365 Days',
              style : {
                'fontSize' : '12px'
              }
          },
          tooltip: {
              enabled : false,
              pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
          },
          accessibility: {
              point: {
                  valueSuffix: '%'
              }
          },
          plotOptions: {
              pie: {
                  size: 150,
                  allowPointSelect: false,
                  cursor: 'pointer',
                  colors: ['#198754', '#dc3545'],
                  dataLabels: {
                      distance: 10,
                      enabled: true,
                      style : {
                        fontSize: '10px',
                        fontWeight: '700'
                      },
                      format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                  }
              }
          },
          credits: {
              enabled: false,
          },
          series: [{
              name: 'PWIDs',
              center: [130, 100],
              colorByPoint: true,
              colors: ['#dc3545', '#198754'],
              data: testedreactive
          },
          {
              name: 'PWIDs',
              center: [400, 100],
              colorByPoint: true,
              colors: [ '#17a2b8', '#ffc107'],
              data: ages
          }],
      });
      return false;
    },
    triggerChart(x) {

      this.loader = true
      this.activeCity = this.chart.series[x].name;
      $(this.chart.series).each(function (i, e) {
        e.hide();
      });
      this.chart.series[x].show()
      this.populatePieCharts(this.chart.series[x].name);
      this.loader = false
    },
    colorizeData(data) {
      data.color = {
          radialGradient: {cx: 0.5, cy: 0.3, r: 0.7},
          stops: [
              [0, data.color],
              [1, Highcharts.Color(data.color).brighten(-0.3).get('rgb')] // darken
          ]
      };
    }
  },
  mounted() {
    this.callPositivePWID();
    this.callPWIDPositiveTested();
    this.callPWID();


  },
};
</script>

<style lang="scss" scoped>
.filter-shaddow {
    filter: drop-shadow(9px 4px 5px rgb(79 79 79 / 93%));
}
#populatePieCharts{
  height: 200px;
}
#container {
  height: 300px;
  // -webkit-box-shadow: -1px 4px 16px -5px rgba(0,0,0,0.93);
  // box-shadow: -1px 4px 16px -11px rgb(0 0 0 / 76%)
}
#containerSpouse {
  height: 500px;
}
.margin-top-minus-150{
  margin-top: -100;
}
.shadow {
  // -webkit-filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.7));
  // filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.7));
  // /* Similar syntax to box-shadow */
  -webkit-box-shadow: -1px 4px 16px -5px rgba(0, 0, 0, 0.93);
  box-shadow: -1px 4px 16px -5px rgba(0, 0, 0, 0.93);
}
#map2 {
  display: none;
}

#map2 .state {
  cursor: pointer;
}

#map2 .state .shape {
  cursor: pointer;
  -width: 0;
}

#map2 .state .label_icon_state {
  fill: #fff;
  font-family: Arial;
  font-size: 11px;
  line-height: 12px;
  font-weight: normal;
}

#map2 .state .label_state {
  display: none;
  font-family: Arial;
  font-size: 14px;
  line-height: 16px;
  font-weight: bold;
}

#map2 .state:hover .label_state,
#map2 .state.hover .label_state {
  display: block;
}

#map2 .model-green .state .shape {
  fill: #e6e6e6;
}

#map2 .model-green .state .icon_state {
  fill: #05110a;
}

#map2 .model-green .state .label_icon_state {
  fill: #fff;
}

#map2 .model-green .state .label_state {
  fill: #666;
}

#map2 .model-green .state:hover .shape,
#map2 .model-green .state.hover .shape {
  fill: #9c9c9c;
}

#map2 .model-green .state:hover .icon_state,
#map2 .model-green .state.hover .icon_state {
  fill: #9c9c9c;
}

#map2 .model-orange .state .shape {
  fill: #fd7132;
}

#map2 .model-orange .state .icon_state {
  fill: #6cb361;
}

#map2 .model-orange .state .label_icon_state {
  fill: #fff;
}

#map2 .model-orange .state .label_state {
  fill: #666;
}

#map2 .model-orange .state:hover .shape,
#map2 .model-orange .state.hover .shape {
  fill: #c93f04;
}

#map2 .model-orange .state:hover .icon_state,
#map2 .model-orange .state.hover .icon_state {
  fill: #10592f;
}

#map2 .model-darkgreen .state .shape {
  fill: #366823;
}

#map2 .model-darkgreen .state .icon_state {
  fill: #2779c6;
}

#map2 .model-darkgreen .state .label_icon_state {
  fill: #fff;
}

#map2 .model-darkgreen .state .label_state {
  fill: #666;
}

#map2 .model-darkgreen .state:hover .shape,
#map2 .model-darkgreen .state.hover .shape {
  fill: #4a8c31;
}

#map2 .model-darkgreen .state:hover .icon_state,
#map2 .model-darkgreen .state.hover .icon_state {
  fill: #5a95ce;
}
.class0-20 {
  fill: rgb(245, 183, 177) !important;
}
.class20-40 {
  fill: rgb(255 141 129) !important;
}
.class40-60 {
  fill: rgb(228 94 80) !important;
}
.class60-100 {
  fill: rgb(226, 23, 23) !important;
}
.class100 {
  fill: #afafaf !important;
}
.text {
  fill: #fff !important;
  font-size: 10px;
  text-shadow: 2px 3px 6px #000;
  font-weight: 700;
  letter-spacing: 1px;
}
.positive-ratio-colors {
  position: absolute;
  top: 35%;
  right: 80px;
}
text {
  fill: #fff !important;
  font-size: 10px;
  text-shadow: 2px 3px 6px #000;
  font-weight: 700;
  letter-spacing: 1px;
}
</style>
